/*
 * @Description:
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { layoutService } from '@/api';
import { reactive, toRefs } from 'vue';
// import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';
// import _ from 'lodash';
import useViewFields from '@/hooks/view-fields';
export default function fieldDefaultVal() {
  const data = reactive({
    defValields: [],
    newFormData: null,
    notDefaluValConfig: [12, 13, 25, 24, 21], //没有默认值规则的类型
    updateSubFormKeys: {}
  });
  // 获取参与默认值规则的字段
  const getDefValFields = async (params) => {
    if (params) {
      return new Promise((resolve, reject) => {
        layoutService
          .getDefValFields(params)
          .then((res) => {
            if (res?.error && res.error?.msg) {
              Message.error(res.error.msg);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    } else {
      return [];
    }
  };
  // 更新表单里的值
  const updateForm = async (getParams) => {
    const getDefaultObj = getParams.setDefaultObj; //结果集
    const getDefaultKeys = getParams.setDefaultKeys;
    const getFormData = getParams.setFormData;
    const getSource = getParams.source;
    const getModules = getParams.modules;
    const { setEditForm } = useViewFields();
    if (getSource == 1) {
      getFormData?.forEach((item) => {
        item?.modules?.forEach((list) => {
          if (list.type == 20) {
            //字段
            const getType = list.setting.fieldType;
            const getKey = list.setting.fieldKey;
            if (!data.notDefaluValConfig.includes(getType) && getDefaultKeys.includes(getKey)) {
              list.fieldValue = setEditForm({ ...list, fieldValue: getDefaultObj[getKey] }).fieldValue;
              if (getType == 18) list.isRefresh = true;
            }
          }
          if (list.type == 35 && list?.modules?.length) {
            //子表单

            const getKey = list.setting.fieldKey;
            if (getDefaultKeys.includes(getKey)) {
              const getSubCustomize = getDefaultObj[getKey];
              const getJsonResult = getSubCustomize?.length && Array.isArray(getSubCustomize) ? getSubCustomize : [];
              list['fieldValue'] = {
                records: [...getJsonResult]
              };
              data.updateSubFormKeys[getKey] = getJsonResult;
            }
          }
        });
      });
      return getFormData;
    }
    if (getSource == 2) {
      getModules?.forEach((item) => {
        if (item.type == 20) {
          //字段
          const getType = item.setting.fieldType;
          const getKey = item.setting.fieldKey;
          const getSubItem = getDefaultObj?.[getParams?.subFormKey]?.[0];
          const getSubItemKey = Object.keys(getSubItem || []);
          if (getSubItemKey?.length > 0) {
            if (!data.notDefaluValConfig.includes(getType) && getSubItemKey.includes(getKey)) {
              item.fieldValue = setEditForm({ ...item, fieldValue: getSubItem[getKey] }).fieldValue;
            }
          }
        }
      });

      return getModules;
    }
  };
  // 获取最新默认值
  const getNewDefVal = async (params, source = 1) => {
    // console.log('params', params);
    data.updateSubFormKeys = {};
    if (params) {
      const { getFormFieldValue } = useViewFields();
      const getFormData = params.formData; //主表数据
      const setParams = {
        entity: params.entity,
        data: {}
      };
      if (source == 1) {
        //主表字段
        setParams['changeFieldKey'] = params?.changeFieldKey ?? null;
      } else {
        //子表单-子字段
        setParams['subFormKey'] = params?.subFormKey ?? null;
      }
      getFormData?.forEach((item) => {
        item?.modules?.forEach((list) => {
          if (list.type == 20 && ![21, 24].includes(list.setting?.fieldType)) {
            //字段
            setParams.data[list.setting.fieldKey] = getFormFieldValue({ ...list, fieldValue: params?.init ? list.defaultValue : list.fieldValue }, 2);
          }
        });
      });
      try {
        const json = source == 1 ? await layoutService.getDefNewVal(setParams, Math.random()) : await layoutService.getSubDefNewVal(setParams, Math.random());
        const getDefaultObj = json?.result || {}; //结果集
        const getDefaultKeys = Object.keys(getDefaultObj);
        if (getDefaultKeys?.length) {
          const setParamsObj = {
            setDefaultObj: getDefaultObj,
            setDefaultKeys: getDefaultKeys,
            setFormData: getFormData,
            source: source,
            subFormKey: params?.subFormKey || null,
            modules: params?.modules || null
          };
          data.newFormData = await updateForm(setParamsObj);
          return data;
        }
      } catch (e) {
        console.log(e);
        return [];
      }
    } else {
      return [];
    }
  };
  return {
    getDefValFields,
    getNewDefVal,
    ...toRefs(data)
  };
}
